import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import useDetectScrollDirection, { ScrollDirection } from '../DiscordButton/hooks/useDetectScrollDirection';
import { useNavbarHeight } from '../Navbar/hooks/useNavbarHeight';

type TTerritorySidebarProps = {
  isOpen: boolean;
  children: ReactNode;
};

export const TerritorySidebar: FC<TTerritorySidebarProps> = ({ isOpen, children }) => {
  const scrollDirection = useDetectScrollDirection();
  const navbarHeight = useNavbarHeight();

  return (
    <div
      className={cx('ease-linear transition-all duration-150 rounded-[12px]', {
        'md:w-[250px] lg:w-[340px]': isOpen,
        'invisible w-0': !isOpen,
      })}
    >
      <div
        className={cx({
          'sticky group/sidebar md:w-[250px] lg:w-[340px] md:duration-200 md:transition-all': isOpen,
          'invisible w-0': !isOpen,
          'md:top-2': scrollDirection === ScrollDirection.down,
        })}
        style={{ top: scrollDirection === ScrollDirection.up ? `${navbarHeight}px` : undefined }}
      >
        {children}
      </div>
    </div>
  );
};
